var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});

// ../../node_modules/.pnpm/eventemitter3@5.0.4/node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
  "../../node_modules/.pnpm/eventemitter3@5.0.4/node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function addListener(emitter, event, fn, context, once) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
      if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
      else emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0) emitter._events = new Events();
      else delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0) return names;
      for (name in events = this._events) {
        if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix ? prefix + event : event, handlers = this._events[evt];
      if (!handlers) return [];
      if (handlers.fn) return [handlers.fn];
      for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
        ee[i] = handlers[i].fn;
      }
      return ee;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix ? prefix + event : event, listeners = this._events[evt];
      if (!listeners) return 0;
      if (listeners.fn) return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a2), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for (i = 1, args = new Array(len - 1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j;
        for (i = 0; i < length; i++) {
          if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i].fn.call(listeners[i].context);
              break;
            case 2:
              listeners[i].fn.call(listeners[i].context, a1);
              break;
            case 3:
              listeners[i].fn.call(listeners[i].context, a1, a2);
              break;
            case 4:
              listeners[i].fn.call(listeners[i].context, a1, a2, a3);
              break;
            default:
              if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i = 0, events = [], length = listeners.length; i < length; i++) {
          if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
            events.push(listeners[i]);
          }
        }
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix;
    EventEmitter2.EventEmitter = EventEmitter2;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter2;
    }
  }
});

// src/errors.ts
import { ErrorResponseErrorCodeEnum } from "@envoy/devices_client";
var DeviceSDKError = class _DeviceSDKError extends Error {
  constructor(message, code, isRetryable, options) {
    super(message);
    Object.setPrototypeOf(this, _DeviceSDKError.prototype);
    this.name = "DeviceSDKError";
    this.code = code;
    this.isRetryable = isRetryable;
    this.serverErrorCode = options?.serverErrorCode;
    if (options?.cause) {
      this.cause = options.cause;
    }
  }
};
var SERVER_ERROR_MAP = {
  // Retryable errors
  [ErrorResponseErrorCodeEnum.IotOperationFailed]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.IotConsistencyError]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.RateLimitExceeded]: { sdkCode: "ENROLLMENT_FAILED", retryable: true },
  [ErrorResponseErrorCodeEnum.AwsIotLimitExceeded]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.ValidationServiceUnavailable]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.IotServiceUnavailable]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.MalformedUpstreamResponse]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: true
  },
  [ErrorResponseErrorCodeEnum.InternalError]: { sdkCode: "ENROLLMENT_FAILED", retryable: true },
  [ErrorResponseErrorCodeEnum.UnexpectedError]: { sdkCode: "ENROLLMENT_FAILED", retryable: true },
  // Non-retryable auth errors
  [ErrorResponseErrorCodeEnum.InvalidToken]: { sdkCode: "AUTHORIZATION_FAILURE", retryable: false },
  [ErrorResponseErrorCodeEnum.ExpiredToken]: { sdkCode: "AUTHORIZATION_FAILURE", retryable: false },
  [ErrorResponseErrorCodeEnum.MissingAuthorization]: {
    sdkCode: "AUTHORIZATION_FAILURE",
    retryable: false
  },
  // Non-retryable enrollment errors
  [ErrorResponseErrorCodeEnum.CompanyBillingInactive]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.LocationInactive]: { sdkCode: "ENROLLMENT_FAILED", retryable: false },
  [ErrorResponseErrorCodeEnum.CrossCompanyConflict]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.UpstreamForceUpgrade]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.InvalidProduct]: { sdkCode: "ENROLLMENT_FAILED", retryable: false },
  [ErrorResponseErrorCodeEnum.InvalidCursor]: { sdkCode: "ENROLLMENT_FAILED", retryable: false },
  [ErrorResponseErrorCodeEnum.DeviceNotFound]: { sdkCode: "ENROLLMENT_FAILED", retryable: false },
  [ErrorResponseErrorCodeEnum.AttributeValidationFailed]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.DeviceNotAssignedToRoom]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.LocationAccessDenied]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.ZoneAccessDenied]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  },
  [ErrorResponseErrorCodeEnum.DeviceDeleted]: {
    sdkCode: "ENROLLMENT_FAILED",
    retryable: false
  }
};
function mapServerError(serverErrorCode, serverMessage, cause) {
  const suffix = serverMessage ? `: ${serverMessage}` : "";
  const mapping = SERVER_ERROR_MAP[serverErrorCode];
  if (mapping) {
    return new DeviceSDKError(
      `Enrollment failed: ${serverErrorCode}${suffix}`,
      mapping.sdkCode,
      mapping.retryable,
      { cause, serverErrorCode }
    );
  }
  return new DeviceSDKError(
    `Enrollment failed: ${serverErrorCode || "unknown error"}${suffix}`,
    "ENROLLMENT_FAILED",
    false,
    { cause, serverErrorCode }
  );
}

// ../../node_modules/.pnpm/eventemitter3@5.0.4/node_modules/eventemitter3/index.mjs
var import_index = __toESM(require_eventemitter3(), 1);
var eventemitter3_default = import_index.default;

export {
  __privateGet,
  __privateAdd,
  __privateSet,
  __privateMethod,
  __privateWrapper,
  eventemitter3_default,
  DeviceSDKError,
  mapServerError
};
